import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { IoReload } from "react-icons/io5";
import { useHistory } from "react-router-dom";
import { TableFilter } from "../../../components/TableListOrders/TableFilter";
import { Pagination } from "../../../components/panel/table/Pagination";
import {
  FieldProps,
  TableContent,
} from "../../../components/panel/table/TableContent";
import { TableHeader } from "../../../components/panel/table/TableHeader";
import { FRONT_LINK } from "../../../global/variables";
import { Client } from "../../../hook/queries/useClients";
import {
  OrderFilters,
  useClientsOrder,
  useOrderFilters,
} from "../../../hook/queries/useOrdersV2";
import { useOrderPages } from "../../../hook/useOrdersPage";
import { setQueryParams } from "../../../hook/useQueryParams";
import { OrderFilter } from "./filters-orders";
import { columns as columnsOrders } from "./list-orders";

const DEFAULT_PAGE = 1;
const DEFAULT_TAB = "Todos";
const DEFAULT_STATUS = ["Aguardando Faturamento"];

const columns: FieldProps<Client>[] = [
  {
    name: "search",
    field: "CLIENTE",
    viewList: false,
  },
  {
    name: "cod",
    field: "CÓD",
    viewList: true,
  },
  {
    name: "company_name",
    field: "RAZÃO SOCIAL",
    viewList: true,
  },
  {
    name: "cnpj",
    field: "CNPJ",
    viewList: true,
  },
  {
    name: "email",
    field: "EMAIL",
    viewList: true,
  },

  {
    name: "uf",
    field: "UF",
    viewList: true,
    render: ({ adresses }) => {
      return adresses ? (
        <span style={{ textTransform: "capitalize" }}>{adresses.uf}</span>
      ) : (
        "-"
      );
    },
  },
  {
    name: "city",
    field: "CIDADE",
    viewList: true,
    render: ({ adresses }) => {
      return adresses ? (
        <span style={{ textTransform: "capitalize" }}>{adresses.city}</span>
      ) : (
        "-"
      );
    },
  },

  {
    name: "isClientContact",
    field: "CONTATO REALIZADO COM CLIENTE EXITO",
    viewList: false,
  },
  {
    name: "status",
    field: "SITUAÇÃO DO CLIENTE",
    viewList: false,
  },
  {
    name: "concept",
    field: "CONCEITO",
    viewList: false,
  },
  {
    name: "concepts",
    field: "CONCEITOS",
    viewList: false,
  },
  {
    name: "city",
    field: "CIDADE",
    viewList: false,
  },
  {
    name: "neighborhood",
    field: "BAIRRO",
    viewList: false,
  },
  {
    name: "reasonNoContact",
    field: "Motivo da falha no contato",
    viewList: false,
  },
  {
    name: "situation",
    field: "SITUAÇÃO DO CLIENTE",
    viewList: true,
    render: ({ situation }) => (
      <span
        style={{
          color: "#fff",
          fontWeight: "bold",
          backgroundColor: String(situation) === "1" ? "#21b543" : "#c52929",
          borderRadius: 6,
          fontSize: 12,
          padding: "4px 6px",
        }}
      >
        {String(situation) === "1" ? "ATIVO" : "INATIVO"}
      </span>
    ),
  },
  {
    name: "scores",
    field: "SCORE DO CLIENTE",
  },
  {
    name: "score",
    field: "SCORE",
    viewList: true,
    render: ({ concept }) => {
      return concept ? (
        <span style={{ textTransform: "capitalize" }}>
          {concept.description}
        </span>
      ) : (
        "-"
      );
    },
  },
];

interface ListOrdersRequest {
  admin?: boolean;
  seller?: boolean;
  client?: boolean;
  filters?: OrderFilters;
  onClearFilter?: () => void;
}

export function ListClientsOrder({ admin }: ListOrdersRequest) {
  const history = useHistory();
  const { setPages, tab, currentPage } = useOrderPages();

  const [viewFilter, setViewFilter] = useState(false);
  const [filters, setFilters] = useState<OrderFilters>(
    currentPage?.filters ?? {}
  );
  const [page, setPage] = useState<number>(currentPage?.page ?? 1);

  const formikFilter = useFormik({
    initialValues: {
      cod: undefined,
      documentNumber: undefined,
      codClient: undefined,
      cnpj: undefined,
      company_name: undefined,
      rejection: undefined,
      canceled: undefined,
      status: undefined,
      statusItem: undefined,
      scores: undefined,
      codSeller: undefined,
      brand: undefined,
      orderPeriod: undefined,
      orderPresetDate: undefined,
      orderSpecificDate: undefined,
      orderStartDate: undefined,
      orderEndDate: undefined,
      billingOrderPeriod: undefined,
      billingOrderPresetDate: undefined,
      billingOrderSpecificDate: undefined,
      billingOrderStartDate: undefined,
      billingOrderEndDate: undefined,
    },
    onSubmit: handleSubmitFilter,
  });

  function handleSubmitFilter(filter: OrderFilters) {
    setFilters(filter);
    setPage(1);
    setViewFilter(false);
  }

  const getClients = useClientsOrder(page, {
    ...filters,
    scoresCod: "5001, 5002, 5003, 5004, 5005, 5006, 5007, 5014",
  });
  const getOrderFilters = useOrderFilters({
    ...filters,
    scoresCod: "5001, 5002, 5003, 5004, 5005, 5006, 5007, 5014",
    statusItem: "Aguardando Faturamento",
  });

  useEffect(() => {
    setPages({ pageKey: tab, page, filters });
    // eslint-disable-next-line
  }, [page, filters]);
  useEffect(() => {
    if (page > 0) {
      setQueryParams({
        data: {
          field: "page",
          value: String(page),
        },
        type: "set",
        history,
      });
    }
    // eslint-disable-next-line
  }, [page, history]);
  useEffect(() => {
    formikFilter.handleReset({});
    // eslint-disable-next-line
  }, [tab]);

  return (
    <>
      <TableFilter
        data={
          getOrderFilters.data?.scores.map((item) => ({
            name: item.name,
            value: String(item.id),
          })) ?? []
        }
        isLoading={getOrderFilters.isLoading || getOrderFilters.isLoading}
        title="Lista de Scores"
        onClick={(score) => {
          setFilters((f) => ({ ...f, scores: score.value }));
        }}
      />

      <OrderFilter
        columns={columnsOrders}
        filters={filters}
        setFilters={setFilters}
        formikFilter={formikFilter}
        onUpdateData={() => {}}
        setViewFilter={setViewFilter}
        viewFilter={viewFilter}
        filtersData={getOrderFilters.data}
      />

      <TableHeader title="CLIENTES">
        <button onClick={() => getClients.refetch()}>
          <IoReload size={19} />
          <span>RECARREGAR</span>
        </button>
      </TableHeader>
      <TableContent<Client>
        data={getClients?.data?.clients ?? []}
        columns={columns.filter((f) => f.viewList)}
        isLoading={getClients.isLoading}
        onClickRow={(row) => {
          const params = new URLSearchParams({
            page: String(DEFAULT_PAGE),
            tab: DEFAULT_TAB,
            status: DEFAULT_STATUS.toString(),
            codClient: String(row.cod),
          });

          const url = `${FRONT_LINK}/${
            admin ? "admin" : "representante"
          }/pedidosV2?${params.toString()}`;

          window.open(url, "_blank");
        }}
      />

      <Pagination
        totalCountOfRegisters={getClients.data?.totalCount ?? 0}
        registersPerPage={getClients.data?.registersPerPage ?? 0}
        currentPage={page}
        onPageChange={(data) => {
          setPage(data);
        }}
      />
    </>
  );
}
